module.exports = __webpack_public_path__ + "img/magazine-title-01.a5e25254.png";